import { Injectable } from '@angular/core';
import { AccountService } from './account.service';
import { UserCredentials, UserImage, ServerResponse } from '../models';
import { EntityType } from '../dictionaries';
import { AppConfig } from './app.config';
import { ServerResponseConverter } from '../converters/server-response-converter';
import { RestService } from './rest.service';
import { error } from 'util';

@Injectable()
export class FilesService {
  constructor(
    private restService: RestService,
    private accountService: AccountService
  ) {
    this.accountService.getCredentialsPromise().then(cred => {
      if (cred) {
        this.userCredentials = cred;
      }
    });
  }

  private controllerUrl = '/v2/File';
  private userCredentials: UserCredentials;

  public uploadImage(image: File = null, folder, entityId, imageString: string = '', imageSize) {
    return new Promise<string>((resolve, reject) => {
      if (image) {
        const myReader: FileReader = new FileReader();
        myReader.onloadend = (e) => {
          const base64string = myReader.result;
          this.fileUpload(base64string, folder, entityId, image.size / 1024).then(resp => resolve(resp), err => reject(err));
        };
        myReader.readAsDataURL(image);
      }
      if (imageString) {
        this.fileUpload(imageString, folder, entityId, imageSize).then(resp => resolve(resp), err => reject(err));
      }
      if (!image && !imageString) {
        resolve('');
      }
    });
  }

  private fileUpload(fileString: string, folder: EntityType, entityId: number, fileSize: number): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const method = '/UploadImage/';
      const imageModel = new UserImage();
      imageModel.AppId = AppConfig.config.AppId;
      imageModel.Data = fileString;
      imageModel.EntityType = folder;
      imageModel.EntityId = entityId;
      imageModel.ImageSize = fileSize;
      imageModel.SessionId = this.userCredentials.Id_Session;

      this.restService.uploadFile(this.controllerUrl + method, imageModel,
        fileString.split(';')[0].split('/')[1]).then(resp => {
          const response: ServerResponse<string> = resp;
          if (response.Result.ReturnCode > 0) {
            resolve(response.Result.Message);
            return;
          }
          reject(response.Result);
        });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/files.service.ts